import React from "react";
import { useStateRestriction } from "../hooks/useStateRestriction";

export default function SCBlockedBanner() {
  const { isSCBlocked, isBlocked, state, loading } = useStateRestriction();

  if (loading || isBlocked || !isSCBlocked) return null;

  return (
    <div
      data-testid="sc-blocked-banner"
      className="mx-auto my-2 w-full max-w-7xl rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-2 text-sm text-amber-100"
    >
      Sweep Coins are currently unavailable in {state || "your state"}. Gold Coins play remains available.
    </div>
  );
}
